import { SignedIn, SignedOut } from "components/clerk";
import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import { H2 } from "components/ui";
import React from "react";
import SignInScreen from "screens/SignInScreen";
export default function Page() {
	return (
		<ScrollContainer>
			<Container>
				<SignedIn>
					<H2>Already signed in</H2>
				</SignedIn>
				<SignedOut>
					<SignInScreen />
				</SignedOut>
			</Container>
		</ScrollContainer>
	);
}
